import { Dispatch, FC, useEffect, useState } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { FileInterface } from "../../../middleware/interfaces/file/file-interface";
import FileVersionList from "./file-version-list";

interface fileVersionDialogProps {
  reveal: boolean;
  selectedFile: FileInterface;
  setSelectedFile: Dispatch<any>;
  setFileVersionDialogReveal: Dispatch<React.SetStateAction<boolean>>;
}

const FileVersionDialog: FC<fileVersionDialogProps> = ({
  reveal,
  selectedFile,
  setSelectedFile,
  setFileVersionDialogReveal,
}) => {
  const [newFileVersion, setNewFileVersion] = useState("");
  const [select, setSelect] = useState(false);

  const HandleCancelClick = () => {
    setFileVersionDialogReveal(false);
  };

  useEffect(() => {
    if (newFileVersion !== "") {
      const updatedSelectedFile = selectedFile;
      updatedSelectedFile.fileActiveVersion = +newFileVersion;
      setSelectedFile(updatedSelectedFile);
      setFileVersionDialogReveal(false);
      setSelect(false);
      setNewFileVersion("");
    }
  }, [newFileVersion]);

  if (reveal === false) {
    return null;
  }
  return (
    <div className="dialogCover" onClick={StopEventPropagation}>
      <div className="dialog">
        <div className="dialogHeader">
          <div className="dialogHeading">
            <h2 className="dialogTitle">Versions</h2>
            <span className="dialogSubtitle">{selectedFile.fileName}</span>
          </div>
          <span className="dialogClose" onClick={HandleCancelClick}>
            ×
          </span>
        </div>
        <FileVersionList
          fileVersions={selectedFile.fileVersions}
          fileActiveVersion={selectedFile.fileActiveVersion}
          select={select}
          setNewFileVersion={setNewFileVersion}
        />
        <div className="dialogButtonWrapper">
          <input
            type="button"
            name="cancel"
            value="Cancel"
            onClick={HandleCancelClick}
          />
          <input
            type="button"
            className="dialogPrimaryButton"
            name="select"
            value="Select"
            onClick={() => {
              setSelect(true);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FileVersionDialog;
